import Columns from './columns';
import {displayModes} from '../../../services/enums/displayModes';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 1,
    columns: {
      boxTypeIdentifier: {
        columnName: Columns.boxTypeIdentifier.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      boxTypeKind: {
        columnName: Columns.boxTypeKind.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      boxTypeVolume: {
        columnName: Columns.boxTypeVolume.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      boxTypeStackable: {
        columnName: Columns.boxTypeStackable.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      boxTypeDimensionsUnit: {
        columnName: Columns.boxTypeDimensionsUnit.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      deleteBoxType: {
        columnName: Columns.deleteBoxType.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
    }
  },
  [displayModes.carrier]: {
    version: 1,
    columns: {}
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {
      boxTypeIdentifier: {
        columnName: Columns.boxTypeIdentifier.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      boxTypeKind: {
        columnName: Columns.boxTypeKind.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      boxTypeVolume: {
        columnName: Columns.boxTypeVolume.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      boxTypeStackable: {
        columnName: Columns.boxTypeStackable.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      boxTypeDimensionsUnit: {
        columnName: Columns.boxTypeDimensionsUnit.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      deleteBoxType: {
        columnName: Columns.deleteBoxType.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
    }
  },
}

export default DefaultConfig;